import { render } from "./tab-panel.vue?vue&type=template&id=7ba75cd4"
import script from "./tab-panel.vue?vue&type=script&lang=js"
export * from "./tab-panel.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__